import { default as indexa2UUcMbXF1Meta } from "/app/src/pages/auth/login/index.vue?macro=true";
import { default as send_45otpO2QmwDn9hoMeta } from "/app/src/pages/auth/login/send-otp.vue?macro=true";
import { default as submit_45otpAAp098wTxsMeta } from "/app/src/pages/auth/login/submit-otp.vue?macro=true";
import { default as indexyhZ3wW3LkIMeta } from "/app/src/pages/auth/signup/index.vue?macro=true";
import { default as infoJoiHr05M16Meta } from "/app/src/pages/auth/signup/info.vue?macro=true";
import { default as submit_45otpFJqeGJfnTYMeta } from "/app/src/pages/auth/signup/submit-otp.vue?macro=true";
import { default as _91id_93Kncx42oKt8Meta } from "/app/src/pages/brief/[id].vue?macro=true";
import { default as _91id_93nCG037MSwyMeta } from "/app/src/pages/campaigns/[id].vue?macro=true";
import { default as indexYuaKlTzgipMeta } from "/app/src/pages/campaigns/index.vue?macro=true";
import { default as _91sid_93Iavbh5tp1SMeta } from "/app/src/pages/compare/[fid]/[sid].vue?macro=true";
import { default as indexTzotCkrmf9Meta } from "/app/src/pages/dashboard/index.vue?macro=true";
import { default as favoritesPKQSU2wep6Meta } from "/app/src/pages/favorites.vue?macro=true";
import { default as point3EC1udqXOhMeta } from "/app/src/pages/history/point.vue?macro=true";
import { default as subscription2rvCDH5EAlMeta } from "/app/src/pages/history/subscription.vue?macro=true";
import { default as transactionKbKOpzAfg2Meta } from "/app/src/pages/history/transaction.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as _91id_93rFr20odRdlMeta } from "/app/src/pages/plans/[id].vue?macro=true";
import { default as indexjwGZutoJJjMeta } from "/app/src/pages/plans/index.vue?macro=true";
import { default as profileTx35vCKuH1Meta } from "/app/src/pages/profile.vue?macro=true";
import { default as _91id_93EwzBA7nIBmMeta } from "/app/src/pages/reports/[id].vue?macro=true";
import { default as indexSSE5up0TcLMeta } from "/app/src/pages/reports/index.vue?macro=true";
import { default as advance0HFqS7zvS7Meta } from "/app/src/pages/search/advance.vue?macro=true";
import { default as index2gRhQT9qIDMeta } from "/app/src/pages/search/index.vue?macro=true";
import { default as resultsDfMVJaYfhUMeta } from "/app/src/pages/search/results.vue?macro=true";
import { default as trendsN5WVzJ1tdAMeta } from "/app/src/pages/trends.vue?macro=true";
import { default as ErrorHd0PG3RaDhMeta } from "/app/src/pages/voucher/Error.vue?macro=true";
import { default as Succeed81EQG7k91wMeta } from "/app/src/pages/voucher/Succeed.vue?macro=true";
export default [
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexa2UUcMbXF1Meta || {},
    component: () => import("/app/src/pages/auth/login/index.vue")
  },
  {
    name: "auth-login-send-otp",
    path: "/auth/login/send-otp",
    meta: send_45otpO2QmwDn9hoMeta || {},
    component: () => import("/app/src/pages/auth/login/send-otp.vue")
  },
  {
    name: "auth-login-submit-otp",
    path: "/auth/login/submit-otp",
    meta: submit_45otpAAp098wTxsMeta || {},
    component: () => import("/app/src/pages/auth/login/submit-otp.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    meta: indexyhZ3wW3LkIMeta || {},
    component: () => import("/app/src/pages/auth/signup/index.vue")
  },
  {
    name: "auth-signup-info",
    path: "/auth/signup/info",
    meta: infoJoiHr05M16Meta || {},
    component: () => import("/app/src/pages/auth/signup/info.vue")
  },
  {
    name: "auth-signup-submit-otp",
    path: "/auth/signup/submit-otp",
    meta: submit_45otpFJqeGJfnTYMeta || {},
    component: () => import("/app/src/pages/auth/signup/submit-otp.vue")
  },
  {
    name: "brief-id",
    path: "/brief/:id()",
    component: () => import("/app/src/pages/brief/[id].vue")
  },
  {
    name: "campaigns-id",
    path: "/campaigns/:id()",
    component: () => import("/app/src/pages/campaigns/[id].vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    component: () => import("/app/src/pages/campaigns/index.vue")
  },
  {
    name: "compare-fid-sid",
    path: "/compare/:fid()/:sid()",
    component: () => import("/app/src/pages/compare/[fid]/[sid].vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/src/pages/dashboard/index.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/app/src/pages/favorites.vue")
  },
  {
    name: "history-point",
    path: "/history/point",
    component: () => import("/app/src/pages/history/point.vue")
  },
  {
    name: "history-subscription",
    path: "/history/subscription",
    component: () => import("/app/src/pages/history/subscription.vue")
  },
  {
    name: "history-transaction",
    path: "/history/transaction",
    component: () => import("/app/src/pages/history/transaction.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexdPwi6hPdMfMeta || {},
    redirect: indexdPwi6hPdMfMeta?.redirect,
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "plans-id",
    path: "/plans/:id()",
    component: () => import("/app/src/pages/plans/[id].vue")
  },
  {
    name: "plans",
    path: "/plans",
    component: () => import("/app/src/pages/plans/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/src/pages/profile.vue")
  },
  {
    name: "reports-id",
    path: "/reports/:id()",
    component: () => import("/app/src/pages/reports/[id].vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/app/src/pages/reports/index.vue")
  },
  {
    name: "search-advance",
    path: "/search/advance",
    component: () => import("/app/src/pages/search/advance.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: index2gRhQT9qIDMeta || {},
    component: () => import("/app/src/pages/search/index.vue")
  },
  {
    name: "search-results",
    path: "/search/results",
    meta: resultsDfMVJaYfhUMeta || {},
    component: () => import("/app/src/pages/search/results.vue")
  },
  {
    name: "trends",
    path: "/trends",
    component: () => import("/app/src/pages/trends.vue")
  },
  {
    name: "voucher-Error",
    path: "/voucher/Error",
    component: () => import("/app/src/pages/voucher/Error.vue")
  },
  {
    name: "voucher-Succeed",
    path: "/voucher/Succeed",
    component: () => import("/app/src/pages/voucher/Succeed.vue")
  }
]